import { render, staticRenderFns } from "./transformerform.vue?vue&type=template&id=8e6b9f8e&scoped=true"
import script from "./transformerform.vue?vue&type=script&lang=js"
export * from "./transformerform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e6b9f8e",
  null
  
)

export default component.exports